export const LocalStorageConstants = {
  OKTA_TOKEN: "okta-token-storage",
  ORIGINAL_URI: "blue-original-uri",
};
